export class StaticIp {
  public name: string;
  public id: string;
  public monthlyCharge: number;
  public initialCharge: number;

  constructor(名前: string, id: string, 初期費用: number, 月額費用: number) {
    this.name = 名前;
    this.id = id;
    this.monthlyCharge = 月額費用;
    this.initialCharge = 初期費用;
  }
}
